import { Card, Form, message, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector, useTranslate } from 'hooks';

import { getKYC, sendQuiz } from 'features/questionnaire/actions';
import { getUserProfile } from 'features/user/actions';

import { language } from 'utils';
import Utils from 'utils/utils';

import { CheckBoxGroup, FormItem, RadioGroup, SubmitButton } from 'componets/form';
import { Loading } from 'componets/ui';

import { Object, QuestionnaireOption, FieldData } from 'models';

import { Paths, RequestStatus, Rules } from 'utils/constants';

import s from './index.module.scss';

const lang = language;

export const KYC = () => {
	const [form] = Form.useForm();

	const { investorQuestionnaireText, nextText } = useTranslate([
		'investorQuestionnaireText',
		'nextText',
	]);

	const navigate = useNavigate();

	const [fields, setFields] = useState<FieldData[]>([]);

	const { kyc, status: requestStatus } = useAppSelector((state) => state.questionnaire);

	const dispatch = useAppDispatch();

	const onFinish = (data: Object) => {
		const body = Utils.formatQuizAnswers(kyc, data);

		dispatch(sendQuiz({ quizId: kyc.id, body }))
			.unwrap()
			.then(() => {
				dispatch(getUserProfile())
					.unwrap()
					.then(() => {
						navigate(Paths.AML, { state: { isKyc: true } });
					});
			})
			.catch((e) => {
				message.warn(e.message);
			});
	};

	useEffect(() => {
		dispatch(getKYC());
	}, [dispatch]);

	const isLoading = requestStatus === RequestStatus.PENDING;

	if (!kyc.texts) return <Loading />;

	return (
		<div className={s.root}>
			<Typography.Title level={4} className={s.title}>
				{investorQuestionnaireText}
			</Typography.Title>

			<Typography.Text>{kyc.texts[lang]}</Typography.Text>
			<div className={s.formWrapper}>
				<Form
					onFinish={onFinish}
					onFieldsChange={setFields}
					fields={fields}
					form={form}
					className={s.form}
					scrollToFirstError
					autoComplete="off"
				>
					{kyc.quests.map((item: any) => {
						const Component = item.quest_type === 'SINGLE' ? RadioGroup : CheckBoxGroup;

						const options = item.options.map((item: QuestionnaireOption) => ({
							value: item.id,
							label: item.texts[lang],
							id: item.id,
						}));

						if (options.length === 0) return '';

						return (
							<Card key={item.id} className={s.card}>
								<div>
									<div
										className={s.question}
										dangerouslySetInnerHTML={{
											__html: item.texts[lang].replace(/href/g, "target='_blank' href"),
										}}
									/>
									<FormItem
										name={item.id}
										rules={[Rules.REQUIRED_ANSWER(item.id)]}
										className="checkboxQuiz"
									>
										<Component options={options} />
									</FormItem>
								</div>
							</Card>
						);
					})}

					<div className={s.submitWrapper}>
						<div className={s.next}>
							<SubmitButton text={nextText} loading={isLoading} />
						</div>
					</div>
				</Form>
			</div>
		</div>
	);
};
